import { userManagement_LABELS } from "../../../../constants/labels/UserManagement";
import { GridColumnDefs } from "../../../../models/Grid/gridColumnDefs";
import Grid from "../../../shared/Grid/Grid";
import Dropdown from "../../../shared/Dropdown/Dropdown";
import { useEffect, useMemo, useState } from "react";
import { UnassignUser } from "../../../shared/SVG/UnassignUser";
import { Button } from "@mui/material";
import "./ClinicUsers.scss";
import {
  useGetClinicLicensesQuery,
  useLazyGetProviderDataQuery,
  useLazyAssignProviderQuery,
  useLazyUnassignProviderQuery,
} from "../../../../services/rtkQueryServices/clinicService";
import ConfirmationDialog from "../../../shared/ConfirmationDialog/ConfirmationDialog";

export function ClinicUsers(Props: any) {
  const [dropDownValue, setDropDownValue] = useState<any>("");
  const [setProvidersInfo, providersInfo] = useLazyGetProviderDataQuery({});
  const {
    data: clinicLicenses,
    refetch,
    isLoading,
    isSuccess,
    isError,
  } = useGetClinicLicensesQuery({});
  const [AssignProvider] = useLazyAssignProviderQuery();
  const [UnassignProvider] = useLazyUnassignProviderQuery();
  const [unassignLicenceKey, setUnassignLicenceKey] = useState<any>(null);
  const rowData = useMemo(() => {
    if (isSuccess && !isLoading) {
      return clinicLicenses?.data?.clinicLicenses;
    }
  }, [clinicLicenses]);
  const isBpSiteIdVerified = useMemo(() => {
    return Props.isBpSiteIdVerified;
  }, [Props.isBpSiteIdVerified]);
  const isSubscriptionActive = useMemo(() => {
    return Props.isSubscriptionActive;
  }, [Props.isSubscriptionActive]);
  useEffect(() => {
    if (isError) {
      Props.isError();
    }
  }, [isError]);
  useEffect(() => {
    isBpSiteIdVerified && isSubscriptionActive && setProvidersInfo({});
  }, [isBpSiteIdVerified, isSubscriptionActive]);
  const selectedProviders = useMemo(() => {
    if (rowData && rowData?.length) {
      return rowData
        .filter((row: any) => row.providerId.length > 0)
        .map((row: any) => row.providerId);
    }
  }, [rowData]);

  useEffect(() => {
    if (selectedProviders?.length === 0) {
      Props.isNoLicencesAssigned(true);
    } else if (selectedProviders) {
      Props.isNoLicencesAssigned(false);
    }
  }, [selectedProviders]);

  const providersData = useMemo(() => {
    if (providersInfo.isSuccess && !providersInfo.isFetching) {
      let res = providersInfo?.data?.data.map((item: any) => {
        return {
          value: item,
          displayValue: item.gpName + " - " + item.providerNo,
        };
      });
      if (selectedProviders) {
        return res?.filter(
          (item: any) => !selectedProviders.includes(item.value.providerNo)
        );
      }
    }
    return [];
  }, [selectedProviders, providersInfo]);

  const RenderProvider = (props: any) => {
    return props?.data?.providerId ? (
      <>{props?.data?.providerName}</>
    ) : (
      <>
        <Dropdown
          menuItems={providersData}
          placeholder={"Providers"}
          name={"Provider"}
          selectedValue={dropDownValue}
          onChange={(value: any) => {
            setDropDownValue(value.value.providerId);
            AssignProvider({
              licenseKey: props?.data?.licenseKey,
              gpUserId: value.value.gpUserId,
            })
              .then((res) => {
                if (res.isSuccess) {
                  refetch();
                  setProvidersInfo({});
                  Props.refetchClinicDetails();
                } else if (res.isError) {
                  Props?.isError();
                }
              })
              .catch((error) => {
                Props?.isError();
              });
          }}
          onInputChange={(event: any, newInputValue: string) => {}}
          searchable
          dropdownSearchInputPlaceHolder={"search"}
        />
      </>
    );
  };

  const RenderActions = (props: any) => {
    return props?.data?.providerId ? (
      <Button
        className={`provider-actions ${
          props?.data?.providerId ? "enable-action" : "disable-action"
        }`}
        onClick={() => {
          setUnassignLicenceKey(props?.data?.licenseKey);
        }}
      >
        <UnassignUser color={"#E47363"} />
        <span className="px-2">Unassign Provider</span>
      </Button>
    ) : (
      <></>
    );
  };
  const columnDefs: GridColumnDefs[] = [
    {
      headerName: userManagement_LABELS.licenceKey,
      field: "licenseKey",
    },
    {
      headerName: userManagement_LABELS.providerName,
      field: "providerName",
      cellRenderer: RenderProvider,
    },
    {
      headerName: userManagement_LABELS.providerId,
      field: "providerId",
    },
    {
      headerName: userManagement_LABELS.role,
      field: "role",
    },
    {
      headerName: userManagement_LABELS.actions,
      field: userManagement_LABELS.actions,
      cellRenderer: RenderActions,
    },
  ];
  return (
    <div className="clinic-users-wrapper">
      <div className="px-3 user-grid-header d-flex justify-content-between">
        <div>{userManagement_LABELS.userManagement}</div>
      </div>
      <div className="clinic-users-grid-wrapper">
        <Grid
          columnDefs={columnDefs}
          rowData={rowData}
          serverSidePagination
          rowCount={5}
          masterDetail
          searchFieldName=""
          withoutHeader={false}
          headerContent={userManagement_LABELS.userManagement}
          showTotalRowCount
          uniqueIdentifierFieldName={"id"}
        ></Grid>
        <ConfirmationDialog
          open={unassignLicenceKey !== null}
          onConfirm={() => {
            UnassignProvider({ licenseKey: unassignLicenceKey })
              .then((res) => {
                if (res.isSuccess) {
                  refetch();
                  setProvidersInfo({});
                  Props.refetchClinicDetails();
                } else if (res.isError) {
                  Props?.isError();
                }
              })
              .catch((error) => {
                Props?.isError();
              });
            setUnassignLicenceKey(null);
          }}
          contentBody={
            <div>
              <div className="confirmation-header">Unassign Provider?</div>
              <div className="pt-3 confirmation-text">
                The provider will be unassigned from the licence.
              </div>
            </div>
          }
          isAlertConfirmation={true}
          confirmButtonName="Unassign"
          onCancel={() => {
            setUnassignLicenceKey(null);
          }}
          cancelButtonClassName={"cancel-button"}
          confirmButtonClassName="confirm-button"
        />
        {((isSubscriptionActive !== null && !isSubscriptionActive) ||
          (isBpSiteIdVerified !== null && !isBpSiteIdVerified)) && (
          <div className="grid-overlay">
            <div className="overlay-text">
              {isSubscriptionActive !== null && !isSubscriptionActive
                ? "Renew your subscription to assign licences."
                : isBpSiteIdVerified !== null &&
                  !isBpSiteIdVerified &&
                  "Verify BP Site ID to assign licences."}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
